import { myName } from './config'
import { syncSharedMiniAssets } from './utils/sharedMiniAssets'

const WEB_SERVICE_WORKER_ACTIVATION_TIMEOUT = 5000

const getWebBaseUrl = () => {
    const currentUrl = new URL(window.location.href)
    const webPath = `/${myName}`
    const webPathIndex = currentUrl.pathname.indexOf(webPath)

    if (webPathIndex === -1) {
        return new URL('./', currentUrl)
    }

    currentUrl.pathname = `${currentUrl.pathname.slice(0, webPathIndex)}${webPath}/`
    currentUrl.search = ''
    currentUrl.hash = ''
    return currentUrl
}

const registerWebServiceWorker = async () => {
    if (
        process.env.NODE_ENV !== 'production' ||
        !('serviceWorker' in navigator)
    ) {
        return null
    }

    try {
        const webBaseUrl = getWebBaseUrl()
        const serviceWorkerUrl = new URL('service-worker.js', webBaseUrl)
        const registration = await navigator.serviceWorker.register(
            serviceWorkerUrl.href,
            {
                scope: webBaseUrl.pathname,
                updateViaCache: 'none',
            },
        )

        const previousActiveWorker = registration.active
        const pendingWorker = registration.installing || registration.waiting
        await new Promise((resolve, reject) => {
            const startedAt = Date.now()
            const timer = window.setInterval(() => {
                const activeWorker = registration.active
                const controller = navigator.serviceWorker.controller
                const activeWorkerIsCurrent = Boolean(
                    activeWorker &&
                    activeWorker.scriptURL === serviceWorkerUrl.href,
                )
                const controllerIsCurrent = Boolean(
                    controller &&
                    controller.scriptURL === serviceWorkerUrl.href,
                )
                const pendingWorkerActivated =
                    !pendingWorker || activeWorker !== previousActiveWorker

                if (
                    activeWorkerIsCurrent &&
                    controllerIsCurrent &&
                    pendingWorkerActivated
                ) {
                    window.clearInterval(timer)
                    resolve()
                    return
                }

                if (
                    Date.now() - startedAt >=
                    WEB_SERVICE_WORKER_ACTIVATION_TIMEOUT
                ) {
                    window.clearInterval(timer)
                    reject(new Error('官网 Service Worker 激活超时'))
                }
            }, 50)
        })
        console.log('官网 Service Worker 已注册')
        return registration
    } catch (error) {
        // Worker 失败不阻塞官网页面，页面仍然可以正常联网运行。
        console.warn('官网 Service Worker 注册失败，继续加载页面', error)
        return null
    }
}

export default async function registerServiceWorker() {
    await Promise.all([
        registerWebServiceWorker(),
        syncSharedMiniAssets(),
    ])
}
